<template>
  <div id="app">
    <router-view name="view" />
    <OrganismTheAlerts/>
    <OrganismTheModal/>
  </div>
</template>

<script>
export default {
  name: 'App',

  components: {
    OrganismTheAlerts: () => import('@/components/organisms/OrganismTheAlerts'),
    OrganismTheModal: () => import('@/components/organisms/OrganismTheModal')
  }
}
</script>

<style src="./styles/main.css"></style>
